"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  background-color: transparent;\n\n  img {\n    width: ", "%;\n    margin: auto;\n  }\n  & + * {\n    margin-top: 20px;\n  }\n"])), function (_ref) {
  var imageType = _ref.imageType;
  return imageType === "retailer" ? 100 : 70;
});

exports.Container = Container;